import React, {Component} from 'react';
import QueryFilterMovimenti from '../movimenti/QueryFilterMovimenti'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import DataFilter from '../DataFilter'
import Moment from 'moment';
import PrintButton from '../PrintButton'
import ElaboraButton from '../ElaboraButton'
import LocalDate from '../LocalDate'
import ReportMovimentiView from './ReportMovimentiView'
import ReportMovimentiViewEc from './ReportMovimentiViewEc'
import FiltriMultiDropdown from '../FiltriMultiDropdown'
import PropTypes from 'prop-types';
class ReportMovimenti extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            filterInfo: {
                conditions: '',
                multiFilter: [],
                tipo: 'p',
                dataStart: Moment().subtract(90, 'days').format("YYYY-MM-DD"),
                dataEnd: Moment().format("YYYY-MM-DD"),
            },
            _loading: false,
            error: null,
            column: null,
            direction: null,
        };
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeQueryFilter = this.onChangeQueryFilter.bind(this)
        this.onChangeMultiFiltri = this.onChangeMultiFiltri.bind(this)
        this.onLoadingMultiFiltri = this.onLoadingMultiFiltri.bind(this)
        this.loadData = this.loadData.bind(this)
    }

    componentWillUnmount() {
    }

    componentDidMount() {
    }

    onLoadingMultiFiltri(loading){
    }

    onChangeMultiFiltri(ev, {name, value}){
        let filter = this.state.filterInfo;
        filter.multiFilter = value;
        this.setState({filterInfo: filter, items:[]})
    }

    onChangeData(tipo, dataDal, dataAl){
        let filter = this.state.filterInfo;
        filter.dataStart = dataDal !== '' ? dataDal : undefined;
        filter.dataEnd = dataAl !== '' ? dataAl : undefined;
        filter.tipo = tipo;
        this.setState({filterInfo: filter, items:[]})
    }

    onChangeQueryFilter(sql){
        let filter = this.state.filterInfo;
        filter.conditions = sql;
        this.setState({filterInfo: filter, items:[]})
    }

    loadData() {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportMovimenti(filterInfo).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }


    render() {
        let i = 1;
        let errorMsg = null;
        if (this.state.error !== null)
        {
            errorMsg =  (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        let reportView = <ReportMovimentiView items={this.state.items}/>;
        let titolo = "Movimenti per PDC"
        if (this.props.tipo === 'ec'){
            reportView = <ReportMovimentiViewEc items={this.state.items}/>
            titolo = "Movimenti per Estratto Conto"
        }

        // let dataStampa = Moment().format("YYYY-MM-DD");
        let tableData = null;
        let stampaButton = null;
        let condizioniAggiuntive = client.getCondizioniAggiuntive(this.state.filterInfo.conditions, this.state.filterInfo.multiFilter);
        if (this.state.items.length > 0){
            stampaButton = <PrintButton/>
            tableData = (
                <div style={{padding:"20px 0"}}>
                    <h3>{titolo} - Filtro: Periodo dal <LocalDate data={this.state.filterInfo.dataStart}/> al <LocalDate data={this.state.filterInfo.dataEnd}/> ; {condizioniAggiuntive ? <span>{condizioniAggiuntive}</span> : null}</h3>
                    {/*<p>Stampa del <LocalDate data={dataStampa}/>. Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b></p>*/}
                    {/*{this.state.filterInfo.conditions ? <p>Condizioni aggiuntive: <b>{this.state.filterInfo.conditions}</b></p> : null}*/}
                    {reportView}
                </div>
            )
        }
        else {

            tableData = (
            <div className="ui segment">
                <h3>Premi il pulsante <em>Elabora</em> per creare il report con i filtri scelti. </h3>
                <p>Filtri correntemente selezionati:</p>
                <p>Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b></p>
                {condizioniAggiuntive ? <p>Condizioni aggiuntive: <b>{condizioniAggiuntive}</b></p> : null}

            </div>)
        }

        return (<div className="ui">
            {errorMsg}
            <h3 className="ui top block attached header no-print">
                <i className="clock icon"/> {titolo}
            </h3>
            <div className="ui attached segment no-print">
            <div className="ui stackable grid">
                <div className="sixteen wide column">
                    <DataFilter
                        tipo={this.state.filterInfo.tipo}
                        dataDal={this.state.filterInfo.dataStart}
                        dataAl={this.state.filterInfo.dataEnd}
                        onChange={this.onChangeData}
                    />
                </div>
                <div className="six wide column">
                    <FiltriMultiDropdown tipo="MOV" name='filtri'
                                         value={this.state.filterInfo.multiFilter}
                                         onChange={this.onChangeMultiFiltri}
                                         onLoading={this.onLoadingMultiFiltri}
                    />
                </div>
                <div className="six wide column">
                            <QueryFilterMovimenti
                                tipo="QRYM1"
                                showPopup={true}
                                value={this.state.filterInfo.conditions}
                                placeholder="Inserisci qui una condizione SQL-like..."
                                onChangeFilter={this.onChangeQueryFilter}
                            />
                </div>
                <div className="four wide column">
                            <ElaboraButton text="Elabora" onClick={this.loadData} /> {stampaButton}
                </div>
            </div>
            </div>

            {tableData}
            {loader}
        </div>)
    }
}

ReportMovimenti.PropTypes = {
    tipo: PropTypes.oneOf([
        'pdc', 'ec'
    ])
}

ReportMovimenti.defaultProps = {
    tipo: 'pdc'
};

ReportMovimenti.contextTypes = {
    router: PropTypes.object
}

export default ReportMovimenti;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportMovimenti.js
 **/